import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-bookings',
  templateUrl: './bookings.component.html'
})
export class BookingsComponent implements OnInit {
  public query: string;
  public itemQuery: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

  public filterItems(query: string): void {
    this.itemQuery = query;
  }

}
